export const QUESTION_BANK = [
  "How can I get a better mortgage rate?",
  "What factors affect my credit score?",
  "How long does it take to improve my credit score?",
];
